import React, { useEffect } from 'react'
import type { ReactNode } from 'react'
import {
  markMilestone,
} from '../../new-relic-transaction/index'
import type {
  HydrationSubtreeMilestone,
} from '../../new-relic-transaction/index'

interface HydrationTimingBoundaryProps {
  children: ReactNode
  milestone: HydrationSubtreeMilestone
}

/**
 * Records the wrapped subtree's readiness after the commit that mounted it:
 * elapsed time from bootstrap start, not the subtree's own CPU time, and no
 * route or user data. `markMilestone` keeps this to one entry per readiness
 * window, so an effect that runs again — a remount, or React invoking it twice —
 * costs a lookup rather than a duplicate milestone.
 */
export default function HydrationTimingBoundary ({
  children,
  milestone,
}: HydrationTimingBoundaryProps) {
  useEffect(() => {
    markMilestone({ milestone })
  }, [milestone])

  return <>{children}</>
}
